import { AfterViewInit, Component, Input, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NavigationHistoryService } from 'src/app/services/navigation-history/navigation-history.service';
import { IconMapping } from './IconMapping ';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { PreferencesService } from 'src/app/services/preference/preferences.service';
@Component({
    selector: 'app-navigation-history',
    templateUrl: './navigation-history.component.html',
    styleUrls: ['./navigation-history.component.scss'],
    standalone: false
})
export class NavigationHistoryComponent implements AfterViewInit {
  @Input() title: string;
  history: any[] = [];
  preferenceKey = 'historyList_view';
  localStoragePreferenceKey = 'historyListPreferences';

  constructor(
    private modal: MatDialogRef<NavigationHistoryComponent>,
    private router: Router,
    private notificationsService: NotificationsService,
    public readonly preferencesService: PreferencesService,
    private cdf: ChangeDetectorRef
  ) { }

  async ngAfterViewInit() {
    this.history = await this.preferencesService.getPreferenceByView(
      this.preferenceKey,
      this.localStoragePreferenceKey
    );
    this.cdf.detectChanges();
  }

  // method to navigate from the list of urls
  navigateToRoute(event: Event, url: string) {
    event.preventDefault();
    this.router.navigateByUrl(url);
    this.onCloseModal();
  }

  // method to return the corresponding icon
  getIconClass(url: string): string {
    const sortedKeys = Object.keys(IconMapping).sort((a, b) => b.length - a.length);
    for (const key of sortedKeys) {
      if (url.includes(key)) {
        const hasSearchParams = ['criteria', 'tag', 'sortOrder', 'sortTyp', 'count', 'page']
          .some(param => url.includes(`${key}?${param}`));

        if (hasSearchParams) {
          return IconMapping['criteria'];
        }

        return IconMapping[key];
      }
    }
    return '';
  }

  // method to copy the url
  copyUrl(url: string): void {
    const baseUrl: string = window.location.origin;
    const fullUrl: string = baseUrl + url;

    const copy = document.createElement('textarea');
    copy.value = fullUrl;
    copy.style.position = 'absolute';
    copy.style.left = '-9999px';
    document.body.appendChild(copy);
    copy.select();
    navigator.clipboard.writeText(fullUrl)
      .then(() => {
        this.notificationsService.successNotification('general.Success', 'general.CopyUrl');
      })
      .catch((err) => {
        this.notificationsService.errorNotification('general.Error', 'general.CopyUrlErr');
      });
  }

  onCloseModal() {
    this.modal.close();
  }
}
